// @ts-nocheck

/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/axios";
import type { UpdateCurrentUserUsersMePatchMutationRequest, UpdateCurrentUserUsersMePatchMutationResponse, UpdateCurrentUserUsersMePatch422 } from "../models/usersController/UpdateCurrentUserUsersMePatch.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/axios";

function getUpdateCurrentUserUsersMePatchUrl() {
  const res = { method: 'PATCH', url: `/users/me` as const }
  return res
}

/**
 * @description Update current authenticated user profile.
 * @summary Update Current User
 * {@link /users/me}
 */
export async function updateCurrentUserUsersMePatch(data: UpdateCurrentUserUsersMePatchMutationRequest, config: Partial<RequestConfig<UpdateCurrentUserUsersMePatchMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<UpdateCurrentUserUsersMePatchMutationResponse, ResponseErrorConfig<UpdateCurrentUserUsersMePatch422>, UpdateCurrentUserUsersMePatchMutationRequest>({ method : "PATCH", url : getUpdateCurrentUserUsersMePatchUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}